import { useSelector } from 'react-redux';
import { useMemo } from 'react';

import { filters, keyHash } from '@mssgme/helpers';

export const getCollections = (state) => state.collections;

export function useCollections(specifier) {
    const selected = useSelector(getCollections);

    return useMemo(() => {
        if (specifier) {
            const items = filters.filterWithExclusion(selected.items, specifier);

            if (items.length !== selected.items.length) {
                const def = items.find((col) => col.default);
                const allPublishedProductsCount = def
                    ? def.publishedProductsCount
                    : items.reduce((acc, col) => acc + col.publishedProductsCount, 0);

                return { ...selected, allPublishedProductsCount, items };
            }
        }

        return selected;
    }, [selected, keyHash(specifier)]);
}
